<template>
  <div class="previewBox" :style="{width: w + 'vw',height: h + 'vh'}" ref="preview" v-if="isShow">
    
    <img
      v-if="val == 'image'"
      :src="src"
      class="childbox"
      alt=""
    />
    <wVideo
      v-if="val == 'video'"
      :src="src"
      class="childbox"
    ></wVideo>

    <iframe
      v-if="val == 'pdf' "
      :src="src"
      style="width: 100%; height: 100%"
    ></iframe>
    <div v-if="val == 'unknown'" class="xz" @click="downloadFile">
       文件格式不支持在线查看请点击下载
      
       <el-button @click="downloadFile">下载</el-button>
       <br>
       <span>{{ src }}</span>
    </div>
  
    <div class="footer">
     
      <div class="boxzoom" v-if="flag">
        W<el-input-number v-model="w"   controls-position="right"  :min="30" :max="100"></el-input-number>
        H<el-input-number v-model="h" style="margin-right: 10px;"  controls-position="right"  :min="30" :max="100"></el-input-number>
      </div>
      <div class="boxzoom" v-else> 
        <div class="el-button el-icon-caret-top"  @mousedown="handleMouseDown(1)"  @mouseup="handleMouseupn()" @mouseout="handleMouseupn()"  ></div>
       <div class="el-button el-icon-caret-bottom"  @mousedown="handleMouseDown(2)"  @mouseup="handleMouseupn()" @mouseout="handleMouseupn()" ></div>
      </div>

      <el-button @click="flag = !flag" class="el-icon-refresh"></el-button>
      
      
       <el-button type="" @click="zoom" class="el-icon-full-screen"></el-button>
       <el-button type="" @click="isShow = false" >关闭</el-button>
    </div>
  </div>
</template>

<script>
import wVideo from "../../components/video-play.vue";
export default {
  props: ["value"],
  data() {
    return {
      val: '',
      src: '',
      isShow: false,
      w: 60,
      h: 60,
      time: null,
      flag: false,
    };
  },

  methods: {
    init(url) {
      this.src = url
      this.isShow = true
      this.val = this.checkFileType(url);
      
    },
    zoom(v = 0){
      
      this.w = this.w <= 60 ? 90 : 60
      this.h = this.h <= 60 ? 80 : 60
    },
    handleMouseDown(v){
      console.log(117)
      if(v == 1){
        this.time = setInterval(()=>{
          if( this.h > 90 || this.w > 90){
            clearInterval(this.time)
            return
          }
         this.w++
         this.h++
      },100)
      }else{
        this.time = setInterval(()=>{
          if( this.h < 40 || this.w < 40){
            clearInterval(this.time)
            return
          }
         this.w--
         this.h--
      },100)
      }
    
     
    },
    handleMouseupn(){
      clearInterval(this.time)
    },
    downloadFile() {
        const link = document.createElement('a');
     
        link.href = this.src
      
        const name = this.src.split(".").pop()
        // link.target="_blank"
        link.setAttribute('download', '文件.' + name); // 为链接设置下载属性
        link.style.display = 'none'; // 隐藏链接

        document.body.appendChild(link); // 将链接添加到页面中
        link.click();
        document.body.removeChild(link)
     
        // const link = document.createElement('a');
        // link.setAttribute('href', this.src);
    
        
        // link.setAttribute("href", "data:text/plain;charset=utf-8," +  this.src);
        // link.setAttribute('download', '文件'); //设置文件名
        // link.setAttribute("type", "application/octet-stream");
        // // document.body.appendChild(link);
        // console.log('22')
        // link.click();
        // link.remove()
    },
    checkFileType(url) {
      const pattern = /\.(jpg|jpeg|png|gif)$/i; // 匹配图片类型

      if (pattern.test(url)) {
        return "image"; // 如果是图片类型，返回 'image'
      }

      // 匹配视频类型
      const videoPattern = /\.(mp4|avi|mov|rmvb|wmv)$/i;
      if (videoPattern.test(url)) {
        
        return "video"; // 如果是视频类型，返回 'video'
      }

      // 匹配 PDF 类型
      const pdfPattern = /\.pdf$/i;
      if (pdfPattern.test(url)) {
        return "pdf"; // 如果是 PDF 类型，返回 'pdf'
      }

      return "unknown"; // 如果无法匹配任何文件类型，返回 'unknown'
    },
  },
  components: {
    wVideo,
  },
};
</script>

<style scoped lang="scss">
.previewBox {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 9999;
  span {
    display: block;
    text-align: center;
  }
}
// .previewBox:hover {
//   width: 60vw;
//   height: 70vh;
//   // transform: scale(5.5);
// }
.childbox {
  // flex: 1;
  width: 100%;
  height: 95%;
}
.xz{
  display: block;
  text-align: center;
  margin: 50px auto;
}
.footer{
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.boxzoom{
  display: inline-block;
  margin-right: 10px;
}
</style>